import { LabelMetaItem, MetaItemSection } from "o4a-react";
import * as React from "react";
import { Stack } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";
import { emptyChar, metaItemLabelsGap } from "../../constants/uiConstants";
import { MdsDbSystem } from "../../gen/clients/mchub-azure-api-client-mds";

export enum MetaItemSectionTestIds {
  INTERNAL_FQN = "mis-internal-fqn",
  IP_ADDRESS = "mis-ip-address",
  MYSQL_PORT = "mis-mysql-port",
  MYSQL_PORT_X = "mis-mysql-port-x",
}

export interface MysqlConnectDetailsProps {
  mdsDbSystem: MdsDbSystem | undefined;
}

export const MysqlConnectDetails = (
  { mdsDbSystem }: MysqlConnectDetailsProps,
): JSX.Element => (
  <Stack style={{ height: "100%" }} tokens={{ childrenGap: 10 }}>
    <MetaItemSection
      title={Messages.detailMysql.overview.sectionTitles.essentials()}
      labelWidth={200}
    >
      <Stack tokens={{ childrenGap: metaItemLabelsGap }}>
        <LabelMetaItem testId={MetaItemSectionTestIds.INTERNAL_FQN} label={Messages.labels.internalFQDN()}>
          {mdsDbSystem?.fqdn || emptyChar}
        </LabelMetaItem>
        <LabelMetaItem testId={MetaItemSectionTestIds.IP_ADDRESS} label={Messages.labels.ipAddress()}>
          {mdsDbSystem?.ipAddress || emptyChar}
        </LabelMetaItem>
        <LabelMetaItem testId={MetaItemSectionTestIds.MYSQL_PORT} label={Messages.labels.mySQLPort()}>
          {mdsDbSystem?.port?.toString() || emptyChar}
        </LabelMetaItem>
        <LabelMetaItem testId={MetaItemSectionTestIds.MYSQL_PORT_X} label={Messages.labels.mySQLPortX()}>
          {mdsDbSystem?.portX?.toString() || emptyChar}
        </LabelMetaItem>
      </Stack>
    </MetaItemSection>
  </Stack>
);
